import { render, staticRenderFns } from "./priceTr.vue?vue&type=template&id=b3b5b3da"
import script from "./priceTr.vue?vue&type=script&lang=js"
export * from "./priceTr.vue?vue&type=script&lang=js"
import style0 from "./priceTr.vue?vue&type=style&index=0&id=b3b5b3da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports